import axios from 'axios';

const api = axios.create({
  baseURL: process.env.NODE_ENV === 'production'
    ? '/api'
    : (process.env.REACT_APP_API_URL || 'http://localhost:5000/api'),
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('vendly_admin_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('vendly_admin_token');
      window.location.href = '/admin/auth';
    }
    return Promise.reject(err);
  }
);

export const adminAuthAPI = {
  login: (email, password) => api.post('/auth/login', { email, password }),
  me:    ()                => api.get('/auth/me'),
};

export const adminOrdersAPI = {
  list:         (params)     => api.get('/orders/all', { params }),
  updateStatus: (id, status) => api.put(`/orders/${id}/status`, { status }),
};

export const adminProductsAPI = {
  list:    (params)       => api.get('/products', { params }),
  pending: ()             => api.get('/products/pending'),
  approve: (id)           => api.post(`/products/pending/${id}/approve`),
  decline: (id, reason)   => api.post(`/products/pending/${id}/decline`, { reason }),
  delete:  (id)           => api.delete(`/products/${id}`),
  toggle:  (id, isActive) => api.put(`/products/${id}`, { isActive }),
  stats:   ()             => api.get('/products/stats'),
};

export const adminSellersAPI = {
  list:    (params)     => api.get('/sellers/all', { params }),
  approve: (id)         => api.post(`/sellers/${id}/approve`),
  decline: (id, reason) => api.post(`/sellers/${id}/decline`, { reason }),
};

export const adminStatsAPI = {
  dashboard: () => api.get('/admin/stats'),
};

export default api;
